<template>
  <div>
    <b-card  title="Tour Overview"> 
     <TourTable />
    <TourCalculation />
    </b-card>
       
  </div>
</template>


<script>
import TourTable from './TourTableLondon.vue';
import TourCalculation from './TourCalculationLondon.vue';

export default {
  components: {
    TourTable,
    TourCalculation
  },
};
</script>



